// extracted by mini-css-extract-plugin
module.exports = {"overflow":"TrendingGenreFilters_overflow__7t8kb"};